import * as React from 'react'
import {
	Collapse,
	ListItemButton,
	ListItemIcon,
	ListItemText,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { ExpandLess, ExpandMore, FolderOutlined, FolderSpecialOutlined } from '@mui/icons-material'
import { useTokenClaims } from '../../security/useTokenClaims'
import { usePermissionContext } from '../../security/PermissionContext'
import { routeData } from '../navigation/RouteData'

type ProjectNavigationDropdownProps = {
	routeInfo: any
}

const projectDetailPermissions =
	routeData.find((route) => route.title === 'Projects' && route.requiredPermissions)
		?.requiredPermissions ?? []

const ProjectNavigationDropdown = ({ routeInfo }: ProjectNavigationDropdownProps) => {
	const [open, setOpen] = React.useState(false)

	const { projectId, role } = useTokenClaims()
	const { hasAnyPermissions } = usePermissionContext()
	const canOpenProjectDetails =
		['ProjectControls', 'SuperAdmin'].includes(role.title) ||
		hasAnyPermissions(projectDetailPermissions)
	const handleClick = () => {
		setOpen(!open)
	}

	const navigate = useNavigate()
	return (
		<>
			{routeInfo.title === 'Projects' && (
				<>
					<ListItemButton onClick={handleClick}>
						<ListItemIcon>
							<ListItemIcon>{routeInfo.icon}</ListItemIcon>
						</ListItemIcon>
						<ListItemText primary={routeInfo.title} />
						{open ? <ExpandLess /> : <ExpandMore />}
					</ListItemButton>
					<Collapse sx={{ marginLeft: '15px' }} in={open} timeout='auto' unmountOnExit>
						{canOpenProjectDetails && (
							<ListItemButton onClick={() => navigate(`/projects/${projectId}/details`)}>
								<ListItemIcon>
									<FolderSpecialOutlined />
								</ListItemIcon>
								<ListItemText primary='Current Project' />
							</ListItemButton>
						)}
						<ListItemButton onClick={() => navigate('/projects')}>
							<ListItemIcon>
								<FolderOutlined />
							</ListItemIcon>
							<ListItemText primary='Assigned Projects' />
						</ListItemButton>
					</Collapse>
				</>
			)}
		</>
	)
}

export default ProjectNavigationDropdown
